import ScrollMagic from 'scrollmagic';

import {scrolEvents} from './default';
import {index} from './index';
import {recruit} from './recruit';
import {eco} from './eco';
import {works} from './works';
import {breadcrumb} from './breadcrumb';
import {vm} from './vm';

document.addEventListener('DOMContentLoaded', function() {
	let scene = [];
	let controller;
    controller =  new ScrollMagic.Controller();
	  vm();
	
    index(controller , scene);
    document.querySelectorAll('.gnavi__list__item').forEach(function(item) {
      item.addEventListener('mouseenter', function() {
        const rect = this.getBoundingClientRect();
        document.documentElement.style.setProperty('--nav-bg-left', rect.left + 'px');
      });
    });

    
  scrolEvents(controller , scene);
  breadcrumb(controller , scene);
	recruit(controller , scene);
	works(controller , scene);
	eco(controller , scene);

  window.addEventListener('resize', setViewport)
  setViewport()
});

function setViewport(){
  const vw = window.innerWidth;
  const vh = window.innerHeight * 0.01
  const head = document.getElementById('site-header')
  document.documentElement.style.setProperty('--vh', `${vh}px`)
  document.documentElement.style.setProperty('--vw', `${vw}px`)
  if(vw < 769){ document.documentElement.style.setProperty('--size', '10px') }
  else if(vw < 1025){ document.documentElement.style.setProperty('--size', '16px') }
  else{ document.documentElement.style.setProperty('--size', '32px') }
  if(head){
    const headSize = head.getBoundingClientRect().height
    document.documentElement.style.setProperty('--head', `${headSize}px`)
  }
}